import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { router } from "@/router";

export default function App() {
  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer 
        position="top-right" 
        autoClose={3000} 
        hideProgressBar={false} 
        style={{ zIndex: 9999 }}
        toastStyle={{
          background: 'rgba(26,26,46,0.9)',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(124,58,237,0.2)',
          color: 'white',
          borderRadius: '12px'
        }}
      />
    </>
  );
}